import React from 'react';
import { motion } from 'framer-motion';
export const MeetArtist = () => {
  return <section className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-146">
      <div className="glass-panel rounded-[40px] md:rounded-[80px] p-8 md:p-16 overflow-hidden relative" data-id="element-147">
        {/* Subtle background glow inside the card */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/20 blur-[100px] rounded-full -z-10" data-id="element-148" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-149">
          {/* Left: Portrait */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative mx-auto lg:mx-0 w-full max-w-sm" data-id="element-150">
            <div className="aspect-[4/5] rounded-t-[140px] rounded-b-[40px] overflow-hidden shadow-[0_25px_60px_-15px_rgba(0,0,0,0.35)]" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/fKQeCTVePKGvSrXNotm4S1/Laura.png" alt="Laura Pinzón" className="w-full h-full object-cover bg-brand-cream/50" data-id="element-152" />
            </div>
            {/* Small floating plaque */}
            <div className="absolute -right-4 md:-right-12 top-1/2 -translate-y-1/2 glass-panel px-6 py-4 rounded-2xl shadow-xl rotate-3" data-id="element-153">
              <p className="font-sans text-xs tracking-widest uppercase text-brand-charcoal/60 mb-1" data-id="element-154">
                Fundadora
              </p>
              <p className="font-serif italic text-xl" data-id="element-155">Nail Artist</p>
            </div>
          </motion.div>

          {/* Right: Bio */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col" data-id="element-156">
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-brand-charcoal/60 mb-4" data-id="element-157">
              La Artista
            </span>
            <h2 className="font-serif text-5xl md:text-6xl text-brand-charcoal mb-8" data-id="element-158">
              Laura Pinzón
            </h2>
            <div className="space-y-6 text-brand-charcoal/80 font-light leading-relaxed text-lg mb-12" data-id="element-159">
              <p data-id="element-160">
                "Mi pasión es transformar el cuidado de las uñas en una
                experiencia de lujo y relajación. Cada set que creo es una obra
                de arte personalizada, diseñada para resaltar la belleza natural
                de mis clientas."
              </p>
              <p data-id="element-161">
                Con años de experiencia y una constante búsqueda de la
                perfección, he establecido un estándar donde la higiene, la
                técnica y el diseño convergen para ofrecer resultados
                impecables.
              </p>
            </div>
            <span className="font-script text-5xl text-brand-charcoal/90 -rotate-2 origin-left" data-id="element-162">
              Laura ✦
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
};